import { useRef, useState } from 'react';
import { LANG_DATA } from '../language/dataset';
import { ToCContainerMobile } from '../styles';
import { ITOC } from '../types';

export const MobileTableOfContent = ({
  content,
  language,
}: ITOC): JSX.Element => {
  const myContainerMobile = useRef(null);
  const [showResults, setShowResults] = useState(false);
  const changeState = () => {
    setShowResults(!showResults);
  };
  return content ? (
    <ToCContainerMobile className="text-s-12 mt-6 xl:hidden md:hidden">
      <div ref={myContainerMobile} id="mobileTOC">
        <div id="inlineTOC">
          <div className="tocHeader" id="tocHeader">
            <div id="sideHead" className="flex">
              <div className="text-base pl-1 font-bold" onClick={changeState}>
                {LANG_DATA[language]?.sideBar.content}
                <span className="ml-2 cursor-pointer">
                  [
                  <span className="px-1 text-cyan-500">
                    {showResults
                      ? LANG_DATA[language]?.sideBar.hide
                      : LANG_DATA[language]?.sideBar.show}
                  </span>
                  ]
                </span>
              </div>
            </div>
            <div
              className={`${showResults ? '' : 'hidden'}`}
              dangerouslySetInnerHTML={{ __html: content.outerHTML }}
            />
          </div>
        </div>
      </div>
    </ToCContainerMobile>
  ) : (
    <ToCContainerMobile className="text-s-12 mt-6 xl:hidden md:hidden h-6"></ToCContainerMobile>
  );
};
